import { render, staticRenderFns } from "./tableLoadingSkeleton.vue?vue&type=template&id=61651dde&scoped=true&"
import script from "./tableLoadingSkeleton.vue?vue&type=script&lang=js&"
export * from "./tableLoadingSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61651dde",
  null
  
)

export default component.exports